<template>
  <v-data-table
    :headers="headers"
    :items="lists"
    :loading="loading"
    density="comfortable"
    class="elevation-0"
    item-key="id"
    @click:row="onRowClick"
  >
    <template #item.last_synced_at="{ item }">{{ formatDate(item.last_synced_at) }}</template>
    <template #item.is_deleted="{ item }">
      <v-chip v-if="item.is_deleted" size="x-small" color="error">
        {{ $t("ncrm.integrations.mailjet.panel.deleted") }}
      </v-chip>
      <v-chip v-else size="x-small" color="success">
        {{ $t("ncrm.integrations.mailjet.panel.active") }}
      </v-chip>
    </template>
    <template #item.show_in_crm_ui="{ item }">
      <v-switch
        :model-value="Boolean(item.show_in_crm_ui)"
        color="primary"
        density="compact"
        hide-details
        inset
        :disabled="togglingId === item.id"
        @update:model-value="toggleVisibility(item, $event)"
      />
    </template>
    <template #no-data>
      <v-alert type="info" class="ma-2">
        {{ $t("ncrm.integrations.mailjet.panel.empty.lists") }}
      </v-alert>
    </template>
  </v-data-table>
</template>
<script>
import axios from "axios";
import { formatDisplayDateTime } from "@/Utile/displayFormat.mjs";
export default {
  name: "NcrmMailjetListsTab",
  props: {
    accountId: { type: [Number, String], default: null },
  },
  emits: ["notify", "open-members"],
  data() {
    return {
      lists: [],
      loading: false,
      togglingId: null,
    };
  },
  computed: {
    headers() {
      return [
        { title: this.$t("ncrm.integrations.mailjet.panel.headers.name"), key: "name" },
        { title: this.$t("ncrm.integrations.mailjet.panel.headers.address"), key: "address" },
        { title: this.$t("ncrm.integrations.mailjet.panel.headers.subscribers"), key: "subscriber_count", align: "end" },
        { title: this.$t("ncrm.integrations.mailjet.panel.headers.lastSynced"), key: "last_synced_at" },
        { title: this.$t("ncrm.integrations.mailjet.panel.headers.status"), key: "is_deleted", sortable: false },
        { title: this.$t("ncrm.integrations.mailjet.panel.headers.showInCrmUi"), key: "show_in_crm_ui", sortable: false, align: "center" },
      ];
    },
  },
  watch: {
    accountId: {
      handler() { this.fetchLists(); },
      immediate: true,
    },
  },
  methods: {
    formatDate(value) {
      if (!value) return "—";
      try { return formatDisplayDateTime(value); } catch (_) { return String(value); }
    },
    extractError(error, fallbackKey) {
      return error?.response?.data?.error || error?.message || this.$t(fallbackKey);
    },
    async fetchLists() {
      if (!this.accountId) return;
      this.loading = true;
      try {
        const { data } = await axios.get(`/ncrm/integrations/mailjet/accounts/${this.accountId}/lists`);
        this.lists = Array.isArray(data?.lists) ? data.lists : [];
      } catch (error) {
        this.$emit("notify", { color: "error", message: this.extractError(error, "ncrm.integrations.mailjet.panel.errors.lists") });
      } finally {
        this.loading = false;
      }
    },
    onRowClick(event, row) {
      if (event?.target?.closest?.(".v-switch")) return;
      const item = row?.item || row;
      if (item) this.$emit("open-members", item);
    },
    async toggleVisibility(item, value) {
      if (!this.accountId || !item?.id) return;
      this.togglingId = item.id;
      try {
        await axios.patch(`/ncrm/integrations/mailjet/accounts/${this.accountId}/lists/${item.id}`, { show_in_crm_ui: Boolean(value) });
        const idx = this.lists.findIndex((row) => row.id === item.id);
        if (idx >= 0) this.lists.splice(idx, 1, { ...item, show_in_crm_ui: value ? 1 : 0 });
        this.$emit("notify", {
          color: "success",
          message: this.$t(
            value
              ? "ncrm.integrations.mailjet.panel.alerts.listVisibilityOn"
              : "ncrm.integrations.mailjet.panel.alerts.listVisibilityOff",
            { name: item.name }
          ),
        });
      } catch (error) {
        this.$emit("notify", { color: "error", message: this.extractError(error, "ncrm.integrations.mailjet.panel.errors.listVisibility") });
      } finally {
        this.togglingId = null;
      }
    },
  },
};
</script>
